import { UserState } from './types';

export function sipNumber(state: UserState) {
    if (!state.sipLogin)
        return '';
    var result = state.sipLogin.match(':(.*)@');
    return result == null ? '' : result.pop();
}
